import { render, staticRenderFns } from "./inboundDetail.vue?vue&type=template&id=4eceea42&"
import script from "./inboundDetail.vue?vue&type=script&lang=js&"
export * from "./inboundDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports